var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value === _vm.id)?_c('img',{staticClass:"checked-img",attrs:{"src":"http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/radio.svg","alt":""},on:{"click":_vm.change}}):_c('img',{staticClass:"checked-img",attrs:{"src":"http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/unradio.svg"},on:{"click":_vm.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }